
<div class="request-quote-container font-rubik p-3 mb-2 flex flex-col gap-3">
  <h3 class="request-quote-h3">Request a quote</h3>
  <p class="request-quote-p">Quickly tell us your needs and we will be in touch shortly</p>
  <div class="flex justify-between">
    <button class="resquest-quote-btn"
      data-vue-init="lead-flow" 
      data-props='{ "gtag": "get_quote"}'  
    >
      Get a Quote
    </button>
    <a href="/contact" class="contact-us-btn flex flex-col items-center justify-center">
      <p>Contact us</p>
    </a>
  </div>
</div>
